export const BANNER_PORTAL_NODE_ID = "banner-portal-node"
